import axiosInstance from './interceptor'


// Get Onboard Request Details
export const getOnboardRequestDetailsForAnalyticReport = async (fromDate:any, toDate:any, stateId: any, asm: any, approverId: any, bucode: any, elecode: any) => {
    let queryParams = [];
    if (stateId && stateId !== 'all') queryParams.push(`stateId=${stateId}`);
    if (asm) queryParams.push(`asm=${asm}`);
    if (approverId) queryParams.push(`approverId=${approverId}`);
    if (bucode && bucode !== 'all') queryParams.push(`bucode=${bucode}`);
    if (elecode) queryParams.push(`elecode=${elecode}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/OnboardClientRequest/GetOnboardRequestsForAnalytics/${fromDate}/${toDate}${queryString}`).then((res: any) => {
        return res
    }).catch((error: any) => { 
        return error.response
    })
}

// Approver api
export const getARUsers = async () => {
    return await axiosInstance.get(`/user/GetARUsers`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Approver api
export const downloadAnalyticsReport = async (fromDate:any, toDate:any, stateId: any, asm: any, approverId: any, bucode: any, elecode: any) => {
    let queryParams = [];
    if (stateId && stateId !== 'all') queryParams.push(`stateId=${stateId}`);
    if (asm) queryParams.push(`asm=${asm}`);
    if (approverId) queryParams.push(`approverId=${approverId}`);
    if (bucode && bucode !== 'all') queryParams.push(`bucode=${bucode}`);
    if (elecode) queryParams.push(`elecode=${elecode}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/OnboardClientRequest/DownloadAnalyticsReport/${fromDate}/${toDate}${queryString}`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get Bottle Order Details
export const getBottleOrderDetailsForAnalyticReport = async (fromDate:any, toDate:any, orderedBy: any, status: any, despatchLocation: any, clientIds: any) => {
    let queryParams = [];
    if (orderedBy && orderedBy !== '') queryParams.push(`orderedBy=${orderedBy}`);
    if (status && status !== '') queryParams.push(`status=${status}`);
    if (despatchLocation && despatchLocation !== '') queryParams.push(`despatchLocation=${despatchLocation}`);
    if (clientIds && clientIds.length > 0) queryParams.push(`clientIds=${clientIds.join(',')}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/BottleOrder/GetOrdersForAnalytics/${fromDate}/${toDate}${queryString}`).then((res: any) => {
        return res
    }).catch((error: any) => { 
        return error.response
    })
}

// Bottle Order Download Report
export const downloadBottleAnalyticsReport = async (fromDate:any, toDate:any, orderedBy: any, status: any, despatchLocation: any, clientIds: any) => {
    let queryParams = [];
    if (orderedBy && orderedBy !== '') queryParams.push(`orderedBy=${orderedBy}`);
    if (status && status !== '') queryParams.push(`status=${status}`);
    if (despatchLocation && despatchLocation !== '') queryParams.push(`despatchLocation=${despatchLocation}`);
    if (clientIds && clientIds.length > 0) queryParams.push(`clientIds=${clientIds.join(',')}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/BottleOrder/DownloadOrdersForAnalytics/${fromDate}/${toDate}${queryString}`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get TAT Dashboard Details
export const getTATDashboardDetails = async (fromDate:any, toDate:any, orderedBy: any, status: any, despatchLocation: any, clientIds: any) => {
    let queryParams = [];
    if (orderedBy && orderedBy !== '') queryParams.push(`orderedBy=${orderedBy}`);
    if (status && status !== '') queryParams.push(`status=${status}`);
    if (despatchLocation && despatchLocation !== '') queryParams.push(`despatchLocation=${despatchLocation}`);
    if (clientIds && clientIds.length > 0) queryParams.push(`clientIds=${clientIds.join(',')}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/BottleOrder/GetBottleDespatchedTATForAnalytics/${fromDate}/${toDate}${queryString}`).then((res: any) => {
        return res
    }).catch((error: any) => { 
        return error.response
    })
}

// Get Quotes Details
export const getQuoteDetailsForAnalyticReport = async (fromDate:any, toDate:any, createdBy: any, clientIds: any) => {
    let queryParams = [];
    if (createdBy && createdBy !== '') queryParams.push(`createdBy=${createdBy}`);
    if (clientIds && clientIds.length > 0) queryParams.push(`clientIds=${clientIds.join(',')}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/quotes/GetQuotesForAnalytics/${fromDate}/${toDate}${queryString}`).then((res: any) => {
        return res
    }).catch((error: any) => { 
        return error.response
    })
}

// Quote Download Report
export const downloadQuoteAnalyticsReport = async (fromDate:any, toDate:any, createdBy: any, clientIds: any) => {
    let queryParams = [];
    if (createdBy && createdBy !== '') queryParams.push(`createdBy=${createdBy}`);
    if (clientIds && clientIds.length > 0) queryParams.push(`clientIds=${clientIds.join(',')}`);

    let queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await axiosInstance.get(`/quotes/DownloadQuotesForAnalytics/${fromDate}/${toDate}${queryString}`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}